import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'navbar',
  templateUrl: './Navbar.component.html',
  styleUrls: ['./Navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  userName: any;
  menuTitle: string = "Workers' Compensation Exemption";
  isLoginPage = false;

  constructor(private router: Router) {
    router.events.subscribe((val) => {
    });
  }
  ngOnInit(): void {}
  openApp(appType: any) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.router.navigate(['/create/'+appType]));
  }
}
